<template>
  <div>
          <a-input></a-input>
         <a-button type="primary"  @click="handleIndex">确定</a-button>
  </div>
</template>
<script>

  import { httpAction, getAction,putAction } from '@api/manage'

export default {
name: "DoctorIndexModal",
  components: {

  },
  data() {
    return {
      form: this.$form.createForm(this),
      info:{},

      url: {

        doctorUser:  "/dwuRelation/dwuRelation/doctorUser",

      },
    };

  },
  methods: {

    handleIndex(e,num){




      // getAction(this.url.info,param).then(res=>{
      //
      //   if(res.success){
      //     this.$message.success(res.message)
      //     this.reload()
      //   }else{
      //     this.$message.warning(res.message)
      //   }
      // })


    }


  },

}
</script>

<style scoped>
#a-drawer{
  height: 200px;
  overflow: hidden;
  position: relative;
  border: 1px solid #ebedf0;
  borderRadius: 2px;
  padding: 48px;
  textAlign: center;
  background: #fafafa;

}
</style>